/** Load-balancer probe. Stays reachable during the window. */
export const HEALTH_CHECK_ROUTE_NAME = 'health-check';

/** Path of {@link HEALTH_CHECK_ROUTE_NAME}. */
export const HEALTH_CHECK_ROUTE_PATH = '/health-check';
